import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import {
  IWorkSchedule,
  IWorkScheduleFilter,
  IOverrideDayOff,
} from "@/features/work-schedule/work-schedule.types";
import { cleanParams } from "@/utils/cleanParams";

export const workScheduleService = {
  getWorkSchedule(filter: IWorkScheduleFilter): Promise<AxiosResponse> {
    return http.get<IWorkSchedule>("/work-schedule/", {
      params: cleanParams(filter),
    });
  },

  overrideDayOff(
    userId: string,
    payload: IOverrideDayOff
  ): Promise<AxiosResponse> {
    return http.post(`/work-schedule/usrs/${userId}/override-day-off`, payload);
  },

  deleteOverrideDayOff(
    userId: string,
    weekStart: string
  ): Promise<AxiosResponse> {
    return http.delete(`/work-schedule/usrs/${userId}/override-day-off`, {
      params: { week_start: weekStart },
    });
  },
};
